module.exports = __webpack_public_path__ + "img/pin2.prt.ceba85e6.jpg";